module.exports = __webpack_public_path__ + "img/mail-varification.206ac89f.png";